import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import GlobalStylesComponent from './styles/GlobalStylesComponent';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Suppress ResizeObserver loop error in development
if (typeof window !== 'undefined') {
  window.addEventListener('error', (e) => {
    if (e.message && e.message.includes('ResizeObserver loop completed with undelivered notifications')) {
      e.stopImmediatePropagation();
    }
  });
}

// Fix for ResizeObserver loop error
const fixResizeObserverLoopError = () => {
  // More robust error handling for ResizeObserver
  const originalConsoleError = window.console.error;
  window.console.error = (...args) => {
    if (
      args[0] && 
      typeof args[0] === 'string' && 
      args[0].includes('ResizeObserver loop') && 
      args[0].includes('completed with undelivered notifications')
    ) {
      // Ignore ResizeObserver loop error
      return;
    }
    originalConsoleError.apply(window.console, args);
  };

  // Add a global error event listener to catch unhandled errors
  window.addEventListener('error', (event) => {
    if (event.message && event.message.includes('ResizeObserver loop')) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return false;
    }
  }, true);
};

// Apply the fix
fixResizeObserverLoopError();

// Suppress non-critical console output in production unless explicitly enabled
const enableDebugLogging = String(process.env.REACT_APP_DEBUG_LOGS || '').toLowerCase() === 'true';
if (typeof window !== 'undefined' && !enableDebugLogging) {
  const noop = () => {};
  const methodsToSilence = [
    'log',
    'info',
    'debug',
    'warn',
    'group',
    'groupCollapsed',
    'groupEnd',
    'table',
    'trace'
  ];
  methodsToSilence.forEach((method) => {
    if (window.console && typeof window.console[method] === 'function') {
      window.console[method] = noop;
    }
  });
}

root.render(
  <>
    <GlobalStylesComponent />
    <App />
  </>
);
